import { z } from 'zod';
import { uuidSchema } from './common';

/**
 * PASS 본인인증 준비(prepare) 응답.
 *
 * 클라이언트는 authUrl 로 대행사 인증창을 열고 formFields 를 POST 로 넘긴다.
 * mock 모드에서는 authUrl 이 "mock:" 접두 placeholder 이고, 프론트 mock 모드가
 * 이 값으로 가짜 인증창을 대신한다.
 */
export const identityPrepareResultSchema = z.object({
  /** 서버가 발급한 거래 ID. 콜백은 이 값으로 원 요청과 대조된다. */
  transactionId: uuidSchema,
  /** 대행사 인증창 URL. */
  authUrl: z.string().min(1),
  /** 인증창에 POST 로 넘길 파라미터. 대행사마다 키 이름이 달라 그대로 전달한다. */
  formFields: z.record(z.string(), z.string()),
});

export type IdentityPrepareResult = z.infer<typeof identityPrepareResultSchema>;

// 날짜는 JSON 전송 계약이므로 ISO 8601 문자열로 주고받는다. (auth 스키마와 동일 원칙)
export const identityStatusSchema = z.object({
  verified: z.boolean(),
  verifiedAt: z.iso.datetime().nullable(),
});

export type IdentityStatus = z.infer<typeof identityStatusSchema>;

/**
 * 대행사 콜백 입력 — 암호화된 인증 결과 원문.
 *
 * 해석·검증은 어댑터(포트 구현)가 담당하므로 여기서는 비어 있지 않은지만 본다.
 */
export const identityCallbackInputSchema = z.object({
  encodedResult: z.string().min(1),
});

export type IdentityCallbackInput = z.infer<typeof identityCallbackInputSchema>;

/**
 * 본인인증 사용 여부 — 비로그인 화면(가입·비회원 견적 링크 등)이 안내 문구를 고르는 데 쓴다.
 * 서버 설정(IDENTITY_PROVIDER)이라 재시작 전에는 바뀌지 않는다.
 */
export const identityAvailabilitySchema = z.object({
  identityRequired: z.boolean(),
});

export type IdentityAvailability = z.infer<typeof identityAvailabilitySchema>;
